<template>
  <apexchart
    ref="CrmPieChart"
    :height="500"
    :options="options"
    :series="series"
    v-if="show"
  >
  </apexchart>
</template>
<script>
export default {
  name: "CrmPieChart",
  data: () => ({
    refreshChart: false,
    series: [],
    options: {},
    show:false
  }),
  mounted() {
   this.crm_brand_distribution()
  },
  methods: {
    async crm_brand_distribution() {
      await this.$http
        .post("/crm_brand_distribution")
        .then((res) => {
          console.log("--/crm_brand_distribution", res.data);
          this.series = res.data.series;
          this.options = res.data.options;
          this.show=true
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.apexcharts-tooltip {
  background: white !important;
}
</style>